import { useRecoilState } from 'recoil';

import { guardianBlockReason } from '../atoms/guardianBlockReason';

export default function useGuardianBlockReason() {
  return useRecoilState(guardianBlockReason);
}
